import { GET_PACKAGE_PANEL_DETAILS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    data: Data[];
    error?: string;
}

export interface Data {
    vendor_id: string;
    included_tests: IncludedTest[];
    type: string;
}

export interface IncludedTest {
    id: string;
    name: string;
    type: string;
}

export default (docId: string = '', ekaId: string = ''): Promise<Response> => {
    return fetchWithRefresh(GET_PACKAGE_PANEL_DETAILS(docId, ekaId)).then((res) => res.json());
};
